// Динамический справочник часовых поясов: единый источник {city, value} (IANA-имя),
// а GMT-смещение в подписи ВЫЧИСЛЯЕТСЯ на лету из tz-базы движка (Intl), а не хранится.
// Почему: статичные «(GMT+X)» устаревают (Казахстан 2024 → Almaty +5, Иран 2022 → Tehran +3:30,
// DST-зоны), и список приходилось править руками сразу в трёх компонентах. Теперь подпись всегда
// соответствует реальному offset зоны на момент загрузки (DST-aware).
//
// Используется в: components/Signup.vue, dashboard/users/CompanyProfile.vue,
// dashboard/branches/Branches.vue. В company.time_zone сохраняется именно value (IANA-имя) —
// его не меняем, чтобы не ломать уже выбранные компаниями зоны.
// Чистый модуль без Vue/i18n → юнит-тестируется (tests/unit/helpers/timezones.spec.js).

// Город (подпись) → IANA-зона. Дубли городов с одной зоной намеренны: человек ищет свой город.
export const TIME_ZONE_CITIES = [
  { city: "International Date Line West", value: "Etc/GMT+12" },
  { city: "Midway Island", value: "Pacific/Midway" },
  { city: "American Samoa", value: "Pacific/Pago_Pago" },
  { city: "Hawaii", value: "Pacific/Honolulu" },
  { city: "Alaska", value: "America/Juneau" },
  { city: "Tijuana", value: "America/Tijuana" },
  { city: "Arizona", value: "America/Phoenix" },
  { city: "Chihuahua", value: "America/Chihuahua" },
  { city: "Mazatlan", value: "America/Mazatlan" },
  { city: "Saskatchewan", value: "America/Regina" },
  { city: "Guadalajara", value: "America/Mexico_City" },
  { city: "Mexico City", value: "America/Mexico_City" },
  { city: "Monterrey", value: "America/Monterrey" },
  { city: "Central America", value: "America/Guatemala" },
  { city: "Bogota", value: "America/Bogota" },
  { city: "Lima", value: "America/Lima" },
  { city: "Quito", value: "America/Lima" },
  { city: "Atlantic Time (Canada)", value: "America/Halifax" },
  { city: "Caracas", value: "America/Caracas" },
  { city: "La Paz", value: "America/La_Paz" },
  { city: "Newfoundland", value: "America/St_Johns" },
  { city: "Georgetown", value: "America/Guyana" },
  { city: "Puerto Rico", value: "America/Puerto_Rico" },
  { city: "Santiago", value: "America/Santiago" },
  { city: "Brasilia", value: "America/Sao_Paulo" },
  { city: "Montevideo", value: "America/Montevideo" },
  { city: "Greenland", value: "America/Godthab" },
  { city: "Mid-Atlantic", value: "Atlantic/South_Georgia" },
  { city: "Azores", value: "Atlantic/Azores" },
  { city: "Cape Verde Is.", value: "Atlantic/Cape_Verde" },
  { city: "Dublin", value: "Europe/Dublin" },
  { city: "Edinburgh", value: "Europe/London" },
  { city: "Lisbon", value: "Europe/Lisbon" },
  { city: "London", value: "Europe/London" },
  { city: "Monrovia", value: "Africa/Monrovia" },
  { city: "UTC", value: "UTC" },
  { city: "Casablanca", value: "Africa/Casablanca" },
  { city: "Belgrade", value: "Europe/Belgrade" },
  { city: "Bratislava", value: "Europe/Bratislava" },
  { city: "Budapest", value: "Europe/Budapest" },
  { city: "Ljubljana", value: "Europe/Ljubljana" },
  { city: "Prague", value: "Europe/Prague" },
  { city: "Sarajevo", value: "Europe/Sarajevo" },
  { city: "Skopje", value: "Europe/Skopje" },
  { city: "Warsaw", value: "Europe/Warsaw" },
  { city: "Zagreb", value: "Europe/Zagreb" },
  { city: "Brussels", value: "Europe/Brussels" },
  { city: "Copenhagen", value: "Europe/Copenhagen" },
  { city: "Madrid", value: "Europe/Madrid" },
  { city: "Paris", value: "Europe/Paris" },
  { city: "Amsterdam", value: "Europe/Amsterdam" },
  { city: "Berlin", value: "Europe/Berlin" },
  { city: "Bern", value: "Europe/Zurich" },
  { city: "Zurich", value: "Europe/Zurich" },
  { city: "Rome", value: "Europe/Rome" },
  { city: "Stockholm", value: "Europe/Stockholm" },
  { city: "Vienna", value: "Europe/Vienna" },
  { city: "West Central Africa", value: "Africa/Algiers" },
  { city: "Bucharest", value: "Europe/Bucharest" },
  { city: "Cairo", value: "Africa/Cairo" },
  { city: "Helsinki", value: "Europe/Helsinki" },
  { city: "Kyiv", value: "Europe/Kiev" },
  { city: "Riga", value: "Europe/Riga" },
  { city: "Sofia", value: "Europe/Sofia" },
  { city: "Tallinn", value: "Europe/Tallinn" },
  { city: "Vilnius", value: "Europe/Vilnius" },
  { city: "Athens", value: "Europe/Athens" },
  { city: "Jerusalem", value: "Asia/Jerusalem" },
  { city: "Harare", value: "Africa/Harare" },
  { city: "Pretoria", value: "Africa/Johannesburg" },
  { city: "Kaliningrad", value: "Europe/Kaliningrad" },
  { city: "Istanbul", value: "Europe/Istanbul" },
  { city: "Minsk", value: "Europe/Minsk" },
  { city: "Moscow", value: "Europe/Moscow" },
  { city: "St. Petersburg", value: "Europe/Moscow" },
  { city: "Volgograd", value: "Europe/Volgograd" },
  { city: "Kuwait", value: "Asia/Kuwait" },
  { city: "Riyadh", value: "Asia/Riyadh" },
  { city: "Nairobi", value: "Africa/Nairobi" },
  { city: "Baghdad", value: "Asia/Baghdad" },
  { city: "Tehran", value: "Asia/Tehran" },
  { city: "Samara", value: "Europe/Samara" },
  { city: "Abu Dhabi", value: "Asia/Muscat" },
  { city: "Muscat", value: "Asia/Muscat" },
  { city: "Baku", value: "Asia/Baku" },
  { city: "Tbilisi", value: "Asia/Tbilisi" },
  { city: "Yerevan", value: "Asia/Yerevan" },
  { city: "Kabul", value: "Asia/Kabul" },
  { city: "Ekaterinburg", value: "Asia/Yekaterinburg" },
  { city: "Islamabad", value: "Asia/Karachi" },
  { city: "Karachi", value: "Asia/Karachi" },
  { city: "Tashkent", value: "Asia/Tashkent" },
  { city: "Chennai", value: "Asia/Kolkata" },
  { city: "Kolkata", value: "Asia/Kolkata" },
  { city: "Mumbai", value: "Asia/Kolkata" },
  { city: "Kathmandu", value: "Asia/Kathmandu" },
  { city: "New Delhi", value: "Asia/Kolkata" },
  { city: "Sri Jayawardenepura", value: "Asia/Colombo" },
  { city: "Almaty", value: "Asia/Almaty" },
  { city: "Astana", value: "Asia/Dhaka" },
  { city: "Dhaka", value: "Asia/Dhaka" },
  { city: "Bishkek", value: "Asia/Bishkek" },
  { city: "Rangoon", value: "Asia/Rangoon" },
  { city: "Urumqi", value: "Asia/Urumqi" },
  { city: "Novosibirsk", value: "Asia/Novosibirsk" },
  { city: "Bangkok", value: "Asia/Bangkok" },
  { city: "Hanoi", value: "Asia/Bangkok" },
  { city: "Jakarta", value: "Asia/Jakarta" },
  { city: "Krasnoyarsk", value: "Asia/Krasnoyarsk" },
  { city: "Beijing", value: "Asia/Shanghai" },
  { city: "Chongqing", value: "Asia/Chongqing" },
  { city: "Hong Kong", value: "Asia/Hong_Kong" },
  { city: "Kuala Lumpur", value: "Asia/Kuala_Lumpur" },
  { city: "Singapore", value: "Asia/Singapore" },
  { city: "Taipei", value: "Asia/Taipei" },
  { city: "Perth", value: "Australia/Perth" },
  { city: "Irkutsk", value: "Asia/Irkutsk" },
  { city: "Ulaanbaatar", value: "Asia/Ulaanbaatar" },
  { city: "Seoul", value: "Asia/Seoul" },
  { city: "Osaka", value: "Asia/Tokyo" },
  { city: "Sapporo", value: "Asia/Tokyo" },
  { city: "Tokyo", value: "Asia/Tokyo" },
  { city: "Yakutsk", value: "Asia/Yakutsk" },
  { city: "Darwin", value: "Australia/Darwin" },
  { city: "Adelaide", value: "Australia/Adelaide" },
  { city: "Brisbane", value: "Australia/Brisbane" },
  { city: "Vladivostok", value: "Asia/Vladivostok" },
  { city: "Guam", value: "Pacific/Guam" },
  { city: "Port Moresby", value: "Pacific/Port_Moresby" },
  { city: "Canberra", value: "Australia/Melbourne" },
  { city: "Melbourne", value: "Australia/Melbourne" },
  { city: "Sydney", value: "Australia/Sydney" },
  { city: "Hobart", value: "Australia/Hobart" },
  { city: "Magadan", value: "Asia/Magadan" },
  { city: "Srednekolymsk", value: "Asia/Srednekolymsk" },
  { city: "Solomon Is.", value: "Pacific/Guadalcanal" },
  { city: "New Caledonia", value: "Pacific/Noumea" },
  { city: "Fiji", value: "Pacific/Fiji" },
  { city: "Kamchatka", value: "Asia/Kamchatka" },
  { city: "Marshall Is.", value: "Pacific/Majuro" },
  { city: "Auckland", value: "Pacific/Auckland" },
  { city: "Wellington", value: "Pacific/Auckland" },
  { city: "Nuku'alofa", value: "Pacific/Tongatapu" },
  { city: "Tokelau Is.", value: "Pacific/Fakaofo" },
  { city: "Chatham Is.", value: "Pacific/Chatham" },
  { city: "Samoa", value: "Pacific/Apia" },
];

// Смещение зоны от UTC в минутах на заданную дату (по умолчанию — сейчас), DST-aware.
// Метод: форматируем дату в целевой зоне «по стенным часам» и сравниваем с UTC-эпохой.
// Опирается только на Intl.DateTimeFormat#formatToParts (поддержан везде, включая Capacitor
// WebView) — надёжнее timeZoneName:"shortOffset". Возвращает null, если зона неизвестна движку.
export function tzOffsetMinutes(timeZone, date = new Date()) {
  try {
    const dtf = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hourCycle: "h23", // без этого полночь может форматироваться как "24" → +1 день
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    const p = {};
    for (const part of dtf.formatToParts(date)) p[part.type] = part.value;
    const wallClockUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    return Math.round((wallClockUTC - date.getTime()) / 60000);
  } catch (e) {
    return null;
  }
}

// Форматирует смещение в минутах как "GMT+6" / "GMT+5:30" / "GMT-3:30".
export function formatOffset(minutes) {
  const sign = minutes < 0 ? "-" : "+";
  const abs = Math.abs(minutes);
  const hours = Math.floor(abs / 60);
  const mins = abs % 60;
  return mins === 0 ? `GMT${sign}${hours}` : `GMT${sign}${hours}:${String(mins).padStart(2, "0")}`;
}

// Опции для v-select/v-autocomplete: [{ text: "(GMT+6) Bishkek", value: "Asia/Bishkek" }, ...],
// отсортированные по реальному offset, затем по названию города. Зоны, неизвестные движку,
// не теряются — попадают в конец списка без GMT-префикса.
export function buildTimeZoneOptions(date = new Date()) {
  return TIME_ZONE_CITIES.map((tz) => {
    const offset = tzOffsetMinutes(tz.value, date);
    return {
      value: tz.value,
      city: tz.city,
      offset,
      text: offset === null ? tz.city : `(${formatOffset(offset)}) ${tz.city}`,
    };
  })
    .sort((a, b) => {
      const ao = a.offset === null ? Infinity : a.offset;
      const bo = b.offset === null ? Infinity : b.offset;
      if (ao !== bo) return ao - bo;
      return a.city.localeCompare(b.city);
    })
    .map((tz) => ({ text: tz.text, value: tz.value }));
}
